<template>
  <div class="min-w-0">
    <label for="text-content" class="block text-sm font-medium text-gray-700 mb-2">
      Text Content
    </label>
    <textarea
      id="text-content"
      :value="modelValue"
      @input="$emit('update:modelValue', $event.target.value)"
      placeholder="Enter text, URL, or any content..."
      aria-label="Text content for QR code"
      class="w-full min-w-0 p-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent resize-none transition-colors"
      rows="4"
      maxlength="2953"
    ></textarea>
    <div class="mt-1 text-sm text-gray-500 text-right">
      {{ modelValue.length }}/2953 characters
    </div>
  </div>
</template>

<script>
export default {
  name: "TextForm",
  props: {
    modelValue: {
      type: String,
      required: true,
    },
  },
  emits: ["update:modelValue"],
};
</script>